import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { environment as ENV } from '@environment';

@Component({
  selector: 'app-exchange-rate-info',
  templateUrl: './exchange-rate-info.component.html',
  styleUrls: ['./exchange-rate-info.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExchangeRateInfoComponent {

  @Input() conversionRate: number;

  public oneMoney: number = 1;

  constructor() { }

  get currencyExchangeName(): string {
    return ENV.countryModules?.booking?.exchange_rate?.currency_to_name;
  }

  get currencyCode(): string {
    return ENV.countryInfo?.currency_code;
  }

}
